<template>
  <section class="is-small">
    <layout-page-menu>
      <template #pageContent>
        <div>
          <DefaultOpeningHours
            :key="'DefaultOpeningHours_' + selectedMeetingtypeId"
            :selectedMeetingtypeId="selectedMeetingtypeId"
            class="mb-6"
          />
          <ExceptionOpeningHours
            :key="'ExceptionOpeningHours_' + selectedMeetingtypeId"
            :selectedMeetingtypeId="selectedMeetingtypeId"
          />
        </div>
      </template>
    </layout-page-menu>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { meetingTypeLabels } from '../../../../utils/stringHelper'

export default {
  name: 'opening-hours',

  components: {
    DefaultOpeningHours: () => import('@/components/Locations/Manage/OpeningHours/DefaultOpeningHours'),
    ExceptionOpeningHours: () => import('@/components/Locations/Manage/OpeningHours/ExceptionOpeningHours'),
  },
  data(vm) {
    const _selectedMeetingtypeId = vm.$store.state.locationStore.location.Meetingtypes[0].MeetingtypeId || 0
    return {
      selectedMeetingtypeId: _selectedMeetingtypeId,
    }
  },
  computed: {
    ...mapState('locationStore', ['location']),

    submenuItems() {
      let output = []

      this.location.Meetingtypes.forEach(element => {
        output.push({
          label: meetingTypeLabels[`type_${element.MeetingtypeId}`] || 'Unknown',
          view: element.MeetingtypeId,
        })
      });

      return output
    }
  },

  provide() {
    // use function syntax so that we can access `this`
    let submenu = []
    Object.defineProperty(submenu, 'menuItems', {
      enumerable: true,
      get: () => this.submenuItems
    })

    return {
      submenu,
      selectedView: this.selectedMeetingtypeId,
      callbackSelectSubmenu: this.setActiveMenu
    }
  },

  methods: {
    setActiveMenu(submenuItem) {
      this.selectedMeetingtypeId = submenuItem.view
    },
  },
}
</script>

<style lang="scss" scoped></style>
